import { render, staticRenderFns } from "./CustomizeMetalA.vue?vue&type=template&id=53f97b2c&scoped=true"
import script from "./CustomizeMetalA.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalA.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalA.vue?vue&type=style&index=0&id=53f97b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f97b2c",
  null
  
)

export default component.exports